import { countries } from "./globals";
import { Languages } from '../components/languages';

const WarehouseOrder_le = Languages.Warehouse.SingleOrderCreation[Languages.selectedLanguage];
const validate_le = Languages.Validate[Languages.selectedLanguage];

export function emptyValidation(fieldName, fieldValue) {

    if (fieldValue == undefined || fieldValue == null || fieldValue.trim() === '') {
        return `${fieldName} ${validate_le.required}`;
    }
    

    return null;
};
export function isTrueValidation(fieldName, fieldValue) {

    if (fieldValue == undefined || fieldValue == null || !fieldValue) {
        return `${fieldName} ${validate_le.required}`;
    }


    return null;
};
export function numberValidation(fieldName, fieldValue) {

    if (fieldValue == undefined || fieldValue==null || fieldValue.trim() === '') {
        return `${fieldName} ${validate_le.required}`;
    }

    if (fieldValue.indexOf(",")<0 && fieldValue.indexOf(".")<0)
        fieldValue = fieldValue + ".00";

    if (!/^(\d+(?:[\.\,]\d{1,3})?)$/.test(fieldValue)) {
        return 'Invalid number';
    }
   
    return null;
};

export function QuantityValidation(id, fieldValue, maxValue) {

    if (!/^\d*$/.test(fieldValue)) {
        return { id, error: WarehouseOrder_le.errors.numberInvalid };
    }

    if (fieldValue == undefined || fieldValue == null || isNaN(fieldValue) || fieldValue.toString().trim() === '') {
        return {id, error: WarehouseOrder_le.errors.mandatoryQuantity};
    }

    fieldValue = Number(fieldValue);

    if (fieldValue % 1 !== 0) {
        return {id, error: WarehouseOrder_le.errors.noDecimalQuantity};
    }

    if (fieldValue <= 0) {
        return {id, error: WarehouseOrder_le.errors.zeroQuantity};
    }

    if (fieldValue > maxValue) {
        return { id, error: WarehouseOrder_le.errors.greaterThanMaxQuantity };
    }

    return {id, error: null};
};

export function phoneValidation(fieldName, fieldValue) {

    if (fieldValue == undefined || fieldValue == null || fieldValue.trim() === '') {
        return '${fieldName} is required';
    }
    if (!/^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/.test(fieldValue)) {
        return 'Invalid characters';
    }

    return null;
};
export function nameValidation(fieldName, fieldValue) {

    if (fieldValue == undefined || fieldValue == null || fieldValue.trim() === '') {
        return '${fieldName} is required';
    }
    if (/[^a-zA-Z]/.test(fieldValue)) {
        return 'Invalid characters';
    }

    return null;
};

export function emailValidation(fieldName, email) {
    if (email === undefined || email == null || email.trim() === '') {
        return `Email ${validate_le.required}`;
    }

    //if (email.startsWith(' ')) {
    //    email = email.replace(/^ */, '');
    //}

    //const emails = email.split(' ');
    //if (emails.length > 1 && emails[1].length > 1) {
    //    return 'Please enter a valid email';
    //}

    if (
        //!/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
        //    email,
        //)
        ! /^[^\s@]+@[^\s@]+\.[^\s@;]+$/.test(email.trim())
    ) {
        return 'Please enter a valid email';
    }

    return null;
};


export function confirmEmailValidation (fieldName, fieldValue) {
    const {email, confirmEmail} = fieldValue;
    if((email !== confirmEmail) || emailValidation(fieldName, confirmEmail)) {
        return 'Please enter a valid email';
    }
    return null;
}

export function zipValidation(fieldName, fieldValue, countryName) {
    if (fieldValue == undefined || fieldValue == null || fieldValue.trim() === '') {
        return `${fieldName} ${validate_le.required}`;
    }

    const foundCountry = countries.find((country => country.name === countryName))
    // console.log(foundCountry, "foundCountry")
    if (foundCountry?.zipCountryValidation && !new RegExp(foundCountry.zipCountryValidation).test(fieldValue)) {
        return 'Invalid zip';
    }

    return null;
};

export function validate(listOfValidateConfig) {
    let withoutError = true;
    for (let i = 0; i < listOfValidateConfig.length; i++) {
        let validateConfig = listOfValidateConfig[i];
        if (validateConfig.validate(validateConfig.fieldName, validateConfig.fieldValue, validateConfig?.countryName) != null) {
            validateConfig.fieldObject[validateConfig.fieldError] = true;
            withoutError = false;
        } else {
            delete validateConfig.fieldObject[validateConfig.fieldError];
        }
    }
    return withoutError;
}
